import { Component, Input } from '@angular/core';

@Component({
  selector: 'date-and-sign',
  templateUrl: './date-and-sign.component.html',
  styleUrls: ['./date-and-sign.component.scss']
})
export class DateAndSignComponent {
  @Input() date?: Date | string | null;
  @Input() initials?: string | null;
}
